<template>
  <div class="col-12">
    <!-- create issue page -->

    <card>

      <div class="row ">
        <div class="col-12 col-md-12">
          <h6>{{ $t("message.Category") }}</h6>
        </div>
        <div class="col-12">
          <el-select class="select-primary issue-category-dropdown" size="large" :placeholder="$t('message.Select category')" v-model="selectedCategory">
            <el-option v-for="category in categories" class="select-primary" :value="category" :label="category" :key="category">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="row issue-detail-section">
        <div class="col-12 col-md-12">
          <h6>{{$t("message.Issue")}}</h6>
        </div>
        <div class="col-12 col-md-12">
          <fg-input v-model="title" :placeholder="$t('message.Whats the issue?')" name="issue" v-validate="modelValidations.issue" :error="getError('issue')">
          </fg-input>
        </div>
      </div>

      <div class="row issue-detail-section">
        <div class="col-12 col-md-12">
          <h6>{{$t("message.Description")}}</h6>
        </div>
        <div class="col-12 col-md-12">
          <fg-input :placeholder="$t('message.Descriptive Notes')">
            <textarea rows="10" v-model="description" :placeholder="$t('message.Describe your issue')"></textarea>
          </fg-input>
        </div>
      </div>

      <!-- Attachments -->
      <div class="row issue-detail-section">
        <div class="col-12">
          <h6>{{ $t("message.Attachments") }}</h6>
        </div>

        <div v-if="attachments && attachments.length > 0" style="width: 100%">

          <div class="col-12" v-for="(attachment,index) in attachments" :key="index">
            <card>
              <div class="row">
                <!-- Thumbnail -->
                <div class="col-2 pr-0">
                  <dynamic-image v-if="attachment.type.indexOf('image') > -1" :file-id="attachment.fileId">
                  </dynamic-image>
                  <dynamic-video v-if="attachment.type.includes('video/')" :file-id="attachment.fileId" class="sc-video" controlsList="nodownload" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0; width: 100%" :options="{controls: true}" />
                  <i class="fa fa-file-pdf-o" style="font-size: 2em" v-if="attachment.type.indexOf('pdf') > -1"></i>
                </div>
                <div @click="viewFile(attachment)" class="col-8" style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;margin: auto;">
                  {{ attachment.name }}
                </div>
                <div class="col-2 col-md-2 col-lg-2" style="color: red;margin:auto;" @click="deleteFile(attachment, index)">
                  <i class="el-icon-delete"></i>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>

      <div style="display: flex;flex-direction: row;justify-content: center;">
        <div>
          <n-button type="primary" simple round @click.native="browseFiles">
            <i class="fa fa-upload pr-1"></i>
            {{ $t("message.Select") }}
          </n-button>
        </div>
        <!-- <div style="margin: 1.2em 0.5em;">
          <span>{{ $t("message.OR") }}</span>
        </div>
        <div>
          <n-button type="primary" simple round @click.native="initiateOpenCamera">
            <i class="fa fa-camera pr-1"></i>
            {{ $t("message.Capture") }}
          </n-button>
        </div> -->
      </div>

      <div class=" row mt-4">
        <div class="col-12">
          <span>
            <i>
              * {{$t("message.Necessary device infromation will be collected")}}
            </i>
          </span>
        </div>
      </div>

      <div class="row justify-content-center " slot="footer">
        <div class="col-md-9 offset-md-3 col-12 text-center">
          <n-button round type="primary" @click.native="submitIssue">
            {{ $t("message.Submit") }}
          </n-button>
        </div>
      </div>

    </card>

  </div>
</template>

<script>
import { Checkbox } from "src/components";

export default {
  components: { Checkbox },

  data() {
    return {
      title: "",
      description: "",
      attachments: [],
      deviceInfo: {},
      appInfo: {
        version: "",
      },
      ALLOW_DEVICE_INFO_COLLECTION: true,
      selectedCategory: null,
      categories: [
        "Video Call",
        "Prescription",
        "Payments",
        "Lab booking",
        "Fitness",
        "Yoga",
        "Meal Plan",
        "Others",
      ],
    };
  },
  mounted(){
    this.changeAppHeaderText("create-issue");
  },

  methods: {
    async browseFiles() {
      let file = await chooser.getFile();

      if (file) {
        this.uploadFile(file);
      }
    },
    async getDeviceInfo() {
      this.appInfo.version = await cordova.getAppVersion.getVersionNumber();

      this.deviceInfo = {
        androidVersion: device.version,
        deviceUUID: device.uuid,
        platform: device.platform,
        manufacturer: device.manufacturer,
        model: device.model,
        serial: device.serial,
      };
    },
    async uploadFile(file) {
      let that = this;
      let loader = that.$loading.show({
        container: null,
        canCancel: false,
      });

      try {
        let response = await that.$store.dispatch("uploadFileToMinio", file);

        var fileDetails = {
          name: file.name,
          type: file.mediaType,
          size: response.fileSize,
          fileId: response.fileId,
        };

        //Save file details in mongo
        try {
          this.attachments.push(fileDetails);
          loader.hide();
          this.$forceUpdate();
          swal.fire({
            title: this.$t("message.File Attached!"),
            type: "success",
            timer: 2000,
          });
        } catch (e) {
          loader.hide();
          console.log("Error updating file share status", e);
          swal.fire({
            title: this.$t("message.File couldn't be shared!"),
            type: "error",
            timer: 5000,
          });
        }
      } catch (e) {
        console.log(e);
        loader.hide();
        swal.fire({
          type: "error",
          title: this.$t("message.File upload error"),
          text: this.$t("message.Could not update the file"),
          timer: 5000,
        });
      }
    },
    async deleteFile(file, index) {
      let _this = this;
      swal
        .fire({
          title: _this.$t("message.Delete File?"),
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: _this.$t("message.Yes"),
          cancelButtonText: _this.$t("message.No"),
          closeOnConfirm: true,
        })
        .then(async (confirm) => {
          if (confirm.value) {
            _this.loader = _this.$loading.show({
              // Optional parameters
              container: null,
              canCancel: false,
            });
            try {
              await _this.$store.dispatch("deleteFileFromMinio", file);
              this.attachments.splice(index, 1);
              _this.loader.hide();
              this.$forceUpdate();
              swal
                .fire({
                  title: _this.$t("message.Success!"),
                  text: _this.$t("message.File deleted successfully"),
                  type: "success",
                  timer: 3000,
                })
                .then(() => {
                  console.log("files :", this.attachments);
                });
            } catch (err) {
              _this.loader.hide();
              swal.fire({
                title: _this.$t("message.Ooops!"),
                text: _this.$t("message.Error while deleting file"),
                type: "error",
                timer: 5000,
              });
            }
          } else {
            swal.close();
          }
        });
    },

    initiateOpenCamera() {
      // open camera
      console.log("open camera function called...");
    },

    async validateDetails() {
      return await this.$validator.validateAll();
    },

    async submitIssue() {
      try {
        let valid = await this.validateDetails();
        if (!valid) {
          return;
        }

        if (this.ALLOW_DEVICE_INFO_COLLECTION) {
          await this.getDeviceInfo();
        }
        let issue = await this.$store.dispatch("createIssue", {
          title: this.title,
          description: this.description,
          attachments: this.attachments,
          deviceInfo: this.deviceInfo,
          appInfo: this.appInfo,
          userRole: this.user.roles[0],
          category: this.selectedCategory,
        });

        if (issue) {
          swal.fire({
            type: "success",
            title: "Issue created successfuly",
            timer: 3000,
          });
        }

        this.$router.back();
      } catch (error) {
        swal.fire({
          type: "error",
          title: "Unable to create issue",
          timer: 3000,
        });
      }
    },
  },

  computed: {
    modelValidations() {
      return {
        issue: {
          required: true,
        },
      };
    },
  },
};
</script>

<style scoped>
.issue-detail-section {
  margin-top: 2em;
}

.issue-category-dropdown {
  width: 100%;
}

/deep/#select-category .IZ-select__input--focused input {
  margin-bottom: 0;
}

/deep/#select-category .IZ-select__menu {
  padding: 0.2em 1em;
  border-radius: 1em;
  border: solid 0.5px #9a9a9a;
  box-shadow: 0px 2px 10px 2px #bdbdbd;
}

/deep/#select-category .IZ-select__item {
  border-bottom: none;
  margin: 0.5em 0;
}
</style>
